// Labels are presentation only. Never use the formatted text for authorization.
export const formatGroupLabel = (value, directory = []) => {
  const item = directory.find(group => group.name === value || group.id === value)
  if (item && item.display_name && item.display_name !== item.name) return item.display_name
  return String(item ? item.name : value).replaceAll('-', ' ').toUpperCase()
}
